import { useEffect } from "react";
import markerSDK from "@marker.io/browser";

export default ({ env }) => {
	useEffect(() => {
		const releaseName = window.__VERSION__;

		if (env.includes("test") || env.includes("canary") || env.includes("preprod")) {
			markerSDK.loadWidget({
				project: "67bf3075559a9a1b667c7c8c",
				silent: true,
				customData: {
					releaseName,
				},
			});
		} else if (env.includes("live")) {
			markerSDK.loadWidget({
				project: "68f0f3d110b48c08800c9cd7",
				silent: true,
				customData: {
					releaseName,
				},
			});
		}
	}, [env]);
};
